export default "$ ? Choose a preset: (Use arrow keys)\n$ > Default (recommended)\n$   Prototype (rapid development)\n$   Configure (advanced)\n";